import $ from 'jquery';

$( '#openMenu' ).click( function () {
	if ( $( '#openMenu' ).hasClass( 'navbar__icon--menu' ) ) {
		$( '.side-nav' ).addClass( 'side-nav--active' );
		$( '#openMenu' ).removeClass( 'navbar__icon--menu' ).addClass( 'navbar__icon--close' );
	} else {
		$( '.side-nav' ).removeClass( 'side-nav--active' );
		$( '#openMenu' ).addClass( 'navbar__icon--menu' ).removeClass( 'navbar__icon--close' );
	}
} )